export default "__VITE_ASSET__BPOAC8pQ__"